import React, { useEffect, useState } from 'react'
import { Button, Form, Row, Col } from 'react-bootstrap'
import { Nav } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';

const MainMenu = () => {
    let isFaex = JSON.parse(sessionStorage.getItem("loginInformation")).StorageType == 'FAEX'


    return (
        <div className="main-menu text-center ">
            <Row className="main-menu-row">
                <Nav.Item className="">
                    <Nav.Link as={Link} className="text-dark main-menu-navitem main-menu-btn" to="/transaction-menu">Postfach</Nav.Link>
                </Nav.Item>
                <Nav.Item className="">
                    <Nav.Link as={Link} className="text-dark main-menu-navitem main-menu-btn" to="/transaction-archive">Lieferarchiv</Nav.Link>
                </Nav.Item>
                <Nav.Item className="">
                    <Nav.Link as={Link} className="text-dark main-menu-navitem main-menu-btn" to="/customer-management">Kundenverwaltung</Nav.Link>
                </Nav.Item>

            </Row>
            <br />
            <Row className="main-menu-row">
                <Nav.Item className="">
                    <Nav.Link as={Link} className="text-dark main-menu-navitem main-menu-btn" to="/inventory1">Bestände</Nav.Link>
                </Nav.Item>
                <Nav.Item className="">
                    <Nav.Link as={Link} className="text-dark main-menu-navitem main-menu-btn" to="/sale-transactions">Verkauf</Nav.Link>
                </Nav.Item>
                <Nav.Item className="">
                    <Nav.Link as={Link} className="text-dark main-menu-navitem main-menu-btn" to="/B2COrder-transactions">Bestellungen</Nav.Link>
                </Nav.Item>
                {/*<Nav.Item className="">*/}
                {/*    <Nav.Link as={Link} className="text-dark main-menu-navitem main-menu-btn"></Nav.Link>*/}
                {/*</Nav.Item>*/}
                {/*<Nav.Item className="">*/}
                {/*    <Nav.Link as={Link} className="text-dark main-menu-navitem main-menu-btn"></Nav.Link>*/}
                {/*</Nav.Item>*/}
                
            </Row>
            {isFaex &&
                <Row>
                    <Nav.Item className="">
                        <Nav.Link as={Link} className="text-dark main-menu-navitem main-menu-btn" to="/miscelaneous-tasks">Datenübernahme</Nav.Link>
                    </Nav.Item>
                </Row>}
        </div>

        //<Nav.Item>
        //        <Nav.Link as={Link} className="text-dark" to="/inventory">&#x25b8;Lagerbestand</Nav.Link>
        //    </Nav.Item>
    )
}

export default MainMenu